module.exports = __webpack_public_path__ + "img/GG.1f21dc20.jpg";